import { CSSProperties } from "react";

interface Props {
  src: string;
  aspect?: number;
  radius?: number;
  className?: string;
  style?: CSSProperties;
}

/**
 * Рендерит превью с правым акцентом в любом aspect ratio через CSS background.
 * Универсально для разных source форматов:
 * - 2:1 (before|after composites): cover scales height fills, width overflows 2× →
 *   background-position right показывает правую половину = «после».
 * - 1:1 (single result, e.g. combine-transfer): cover = exact fit, position right
 *   irrelevant (no overflow), показывает целое изображение.
 * - 16:9 / другие: cover crops longer dim, position right shows right portion.
 */
export function AfterCrop({ src, aspect = 1, radius = 0, className, style }: Props) {
  return (
    <div
      className={className}
      style={{
        aspectRatio: String(aspect),
        borderRadius: radius,
        backgroundColor: "#1a1a1a",
        backgroundImage: `url(${src})`,
        backgroundSize: "cover",
        backgroundPosition: "right center",
        backgroundRepeat: "no-repeat",
        ...style,
      }}
    />
  );
}
